export default __webpack_public_path__ + "static/036-9aeefef5f170641f0ce38f0ef30ce3d1.png";